<dialog-gala (clickClose)="askHideModal()">
  <span gala-dialog-titre>{{lgTrad.MODSURFACES + ' ' + ((surfaces.RFMILLESIME) ?
  surfaces.RFMILLESIME.MILLESIME : '')}}</span>
  @if (formData) {
    <form [formGroup]="formData" autocomplete="off">
      <div class="table-surface col-4 table-rf-surface">
        <table class="table table-striped table-smaller table-not-rounded">
          <caption class="caption-sm caption-rounded">
            <div class="row">
              <div class="col-md-8">{{lgTrad.SURFACES}}</div>
              <div class="col-md-3 text-right">
                @if (droitsAccess.write) {
                  <add-button class="pr-2 tab-btn-roundadd" (click)="showModalRfSurface()"
                    />
                }
              </div>
            </div>
          </caption>
          <thead>
            <tr class="surface-titre">
              <th colspan="2">&nbsp;</th>
            </tr>
            <tr>
              <th>{{lgTrad.TYPE}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (rf of rfSurfacesListe; track rf) {
              <tr>
                <ng-container>
                  @if (checkTabulation(rf) === 0) {
                    <td>{{rf.LBLSURFACE}}</td>
                  }
                  @if (checkTabulation(rf) === 1) {
                    <td class="pl-10px">
                    {{rf.LBLSURFACE}}</td>
                  }
                  @if (checkTabulation(rf) === 2) {
                    <td class="pl-15px">
                    {{rf.LBLSURFACE}}</td>
                  }
                  @if (checkTabulation(rf) === 3) {
                    <td class="pl-20px">
                    {{rf.LBLSURFACE}}</td>
                  }
                  <td class="text-right">
                    @if (droitsAccess.write && isSurfaceSupprimable(rf)) {
                      <gala-btn-delete [small]="true" class="small-btn"
                        (click)="askSupprimerSurface(rf)" />
                    }
                    @if (!isSurfaceSupprimable(rf) && checkHasChildren(rf)) {
                      <span class="clickable"
                        (click)="calculerValeurs(rf)"><i class="fas fa-calculator fa-lg"></i></span>
                      }
                    </td>
                  </ng-container>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="table-surface col-8">
          <table class="table table-striped table-smaller table-not-rounded">
            <caption class="caption-sm caption-rounded">
              <div class="row">
                <div class="col-md-12">{{(surfaces.RFMILLESIME) ? surfaces.RFMILLESIME.MILLESIME :
                ''}}</div>
              </div>
            </caption>
            <thead>
              <tr class="surface-titre">
                <th colspan="2">{{lgTrad.TOTAL}}</th>
                <th colspan="2">{{lgTrad.ATELIERLAIT}}</th>
              </tr>
              <tr class="surface-annee">
                <th>Surf</th>
                <th>Rend</th>
                <th>Surf</th>
                <th>Rend</th>
              </tr>
            </thead>
            <tbody>
              @for (curSurface of firstForm.controls; track curSurface; let index = $index) {
                <tr formArrayName="FIRSTFORM"
                  class="surface-annee">
                  <ng-container [formGroupName]="index">
                    <td>
                      <input-gala formControlName="SURFTOTAL" placeholder="--" type="number"
                        [disabled]="!checkRfSurface(index)"
                        customClass="form-control-xs-w input-text-number"
                        (keyup)="premiereSaisie(curSurface)" max="9999" />
                      </td>
                      <td>
                        @if (checkRendement(index)) {
                          <input-gala formControlName="RDTTOTAL" placeholder="--"
                            type="number" [disabled]="!checkRfSurface(index)"
                            customClass="form-control-xs-w input-text-number"
                            (keyup)="premiereSaisie(curSurface)" max="9999" />
                        }
                      </td>
                      <td>
                        <input-gala formControlName="SURFLAIT" placeholder="--" type="number"
                          [disabled]="!checkRfSurface(index)"
                          customClass="form-control-xs-w input-text-number"
                          (keyup)="formatNombreDecimals(curSurface)" max="9999" />
                        </td>
                        <td>
                          @if (checkRendement(index)) {
                            <input-gala formControlName="RDTLAIT" placeholder="--"
                              type="number" [disabled]="!checkRfSurface(index)"
                              customClass="form-control-xs-w input-text-number"
                              (keyup)="formatNombreDecimals(curSurface)" max="9999" />
                          }
                        </td>
                      </ng-container>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </form>
        }
        <div gala-dialog-actions>
          @if (droitsAccess.write) {
            <button mat-stroked-button color="primary" (click)="enregistrerSurface()"
            >{{lgTrad.ENR}}</button>
          }
          <button mat-stroked-button color="accent" (click)="askHideModal()">{{lgTrad.RET}}</button>
        </div>
      </dialog-gala>